<template>
  <router-link 
    :class="[ 
      'route mx-3',
      { 'primary--text': routeMatched, 'text-caption':$vuetify.breakpoint.smAndDown }
    ]"
    :to="{ name: routeName }" 
  >
    <!-- text -->
    <span class="font-weight-light text-center w-100">
      <slot></slot>
    </span>
    <!-- underline -->
    <transition name="active">
      <div
        v-show="routeName === $route.name" 
        class="underline mx-auto success"
      />
      </transition>
  </router-link>
</template>

<script>
  export default {
    name: 'AppHeaderRouter',
    
    props: {
      routeName: {
        type: String,
        default: '/'
      }
    },

    computed: {
      routeMatched() { return this.routeName === this.$route.name }
    },
  }
</script>

<style lang="scss" scoped>
  a {
    color:black;
    text-decoration: none;
  }

  .route {
    height: 3vh;
  }

  .underline {
    width: 40px;
    height: 3px;
    border-radius: 25px ;

  }

  .active-enter-active, .active-leave-active {
    transition: width .2s
  }
  
  .active-enter, .active-leave-to {
    width: 0px;
  }

</style>